import { deepFreeze } from 'utils/deepFreeze';
import { FavouritesExperienceState } from '../types';

export const initialState: Readonly<FavouritesExperienceState> = deepFreeze({});
